// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"326":"84ee8e28d9eaa222","769":"aced68791ebf214a"}[chunkId] + ".css";
};